import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHotDrinkCup: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="hot-drink-cup,coffee-mug,dup, mug"><path d="M20.25 5.75H3.75V8.75H20.25V5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.5 5.5L6.49997 2.75H17.5L18.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 8.97913L5.91667 21.25H18.0833L19.25 8.99996" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHotDrinkCup;
